var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImageNotFound(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29.567,
    height: 29.567,
    viewBox: "0 0 29.567 29.567",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "image_not_supported_FILL0_wght600_GRAD0_opsz48",
    d: "M56.905-857.738,53.946-860.7H34.272a2.6,2.6,0,0,1-1.905-.792,2.6,2.6,0,0,1-.792-1.905v-19.673l-2.619-2.6,1.618-1.637,27.949,27.949Zm-22.633-5.656H51.248l-3.913-3.913H36.142l4.086-4.767,2.724,3.711L44.5-870.2,34.272-880.4Zm22.8-.326-2.717-2.7v-17.06H37.3l-2.7-2.717H54.356a2.616,2.616,0,0,1,1.919.8,2.616,2.616,0,0,1,.8,1.919v19.758ZM45.928-874.846ZM42.8-871.866Z",
    transform: "translate(-28.956 887.305)",
    fill: "#afafaf"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageNotFound);
export default __webpack_public_path__ + "static/media/image_not_found.344d178a0c36c9220d66ddaad8ecb9b7.svg";
export { ForwardRef as ReactComponent };